import React from "react";
import { Facebook, Instagram, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-950 text-gray-400 pt-12 pb-6">
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Brand Section */}
        <div>
          <h2 className="text-2xl font-bold text-white tracking-wide">Pixel Prime</h2>
          <p className="mt-3 text-sm leading-relaxed text-gray-500 max-w-xs">
            Crafting digital experiences that inspire, engage, and deliver results.
          </p>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-col md:items-center" aria-label="Footer Navigation Links">
          <h3 className="text-white font-semibold mb-3">Quick Links</h3>
          <div className="flex flex-col space-y-2 text-sm">
            {["About", "Services", "Projects", "Contact"].map((link) => (
              <a
                key={link}
                href={`#${link.toLowerCase()}`}
                className="hover:text-gray-100 transition-colors duration-300"
              >
                {link}
              </a>
            ))}
          </div>
        </nav>

        {/* Social Media */}
        <div className="md:justify-self-end">
          <h3 className="text-white font-semibold mb-3">Connect with us</h3>
          <div className="flex space-x-5">
            <a
              href="https://facebook.com"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition transform hover:scale-110 duration-300"
            >
              <Facebook size={22} />
            </a>
            <a
              href="https://instagram.com"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition transform hover:scale-110 duration-300"
            >
              <Instagram size={22} />
            </a>
            <a
              href="https://linkedin.com"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition transform hover:scale-110 duration-300"
            >
              <Linkedin size={22} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 mt-10 pt-5 text-center text-sm text-gray-500 select-none">
        © {new Date().getFullYear()} Pixel Prime. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
